import { flexCenter, flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { ItemCardProps } from './types';

const headerOnMobile = media.phone`
 ${flexColumn};
 align-items: flex-start;
 a {
   margin-top: 5px;
 }
`;

export const Header = styled.div`
  ${flexRow};
  margin-bottom: 28px;
  align-items: flex-end;
  justify-content: space-between;
  a {
    color: #292a2b;
    margin-bottom: 8px;
    text-decoration: underline;
  }
  ${headerOnMobile};
`;

export const Content = styled.div`
  ${flexRow};
  overflow: hidden;
  position: relative;
`;

export const ItemWrapper = styled.div`
  margin-right: 20px;
`;

export const ItemCard = styled.div<ItemCardProps>`
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  min-width: ${({ size }) => size}px;
  border: 1px solid rgba(1, 83, 130, 0.2);
  img {
    object-fit: cover;
  }
  video {
    ${({ isVerticalVideo }) =>
      isVerticalVideo
        ? css`
            height: unset;
          `
        : css`
            width: unset;
          `}
  }
`;

export const ItemTitle = styled.p`
  color: #292a2b;
  font-size: 16px;
  margin: 16px 0 0;
  font-weight: 700;
  min-height: 50px;
  line-height: 25px;
  text-align: center;
  font-style: normal;
`;

export const DateBudge = styled.div`
  right: 9px;
  bottom: 9px;
  width: 50px;
  height: 50px;
  z-index: 125;
  background: #fff;
  border-radius: 5px;
  position: absolute;
`;

export const DateCell = styled.div`
  ${flexCenter};
  color: #292a2b;
  font-size: 24px;
  font-weight: 700;
  padding-top: 5px;
  line-height: 25px;
`;

export const DayCell = styled.div`
  ${flexCenter};
  color: #919eaa;
  font-size: 12px;
  font-weight: 400;
`;

export const TransparentOverlay = styled.div`
  right: 0;
  width: 40px;
  height: 100%;
  z-index: 126;
  position: absolute;
  background: linear-gradient(270deg, #fff4db 0%, rgba(255, 244, 219, 0) 100%);
`;

const Wrapper = styled.div`
  background: #fff4db;
  border-radius: 20px;
  margin: 21px 40px 71px;
  padding: 20px 30px 33px;
`;

export default Wrapper;
